import { FC, useMemo } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import Breadcrumb, {
  BreadcrumbItem,
} from 'modules/_shared/components/Breadcrumb';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import { useAddTradingOfferPage } from './context/AddTradingOfferPageContext';
import AddTradingOfferPageBody from './components/AddTradingOfferPageBody';

const AddTradingOfferPage: FC = () => {
  const { t } = useTranslate();

  // const { data, actions } = useOperationsListPage();

  const { data } = useAddTradingOfferPage();

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('Dashboard'), to: '/' },
      { label: data.societyName, to: `/sociedad/${data.societyId}` },
      {
        label: t('EquityMarket'),
        to: `/mercado-de-acciones/${data.societyId}`,
      },
      { label: t('ShareSaleOffer'), isActive: true },
    ],
    [t, data.societyName, data.societyId]
  );

  const pageActions = [<GoBackButton key="go-back" icon="ni-arrow-left" />];

  return (
    <Page>
      <div className="nk-block-head-content mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <PageListHeader
        subTitle={t('ShareSaleOffer')}
        description={t('ShareSaleOfferDescription')}
        actions={pageActions}
      />

      <AddTradingOfferPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default AddTradingOfferPage;
